import { useEffect } from 'react'
import { useFeatureTogglesStore } from 'stores/featureTogglesStore'

const BIBLION_TITLE =
  'BibliON - A Biblioteca Digital Gratuita do Estado de São Paulo'
const BIBLION_DESCRIPTION =
  'A biblioteca digital gratuita do Estado de São Paulo ao seu alcance! Livros, audiolivros, podcasts e muito mais para os moradores de todo o Brasil, de qualquer lugar, a qualquer momento.'
const BIBLION_FAVICON = '/images/favicon-biblion.ico'

export function BiblionBranding() {
  const { featureToggles } = useFeatureTogglesStore()
  const isBiblion =
    featureToggles?.biblionGeneral === true ||
    featureToggles?.biblionPanel === true

  useEffect(() => {
    if (!isBiblion) {
      return
    }

    document.title = BIBLION_TITLE

    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', BIBLION_DESCRIPTION)

    const iconLinks = document.querySelectorAll<HTMLLinkElement>(
      'link[rel="icon"], link[rel="shortcut icon"]'
    )
    iconLinks.forEach(link => {
      link.type = 'image/x-icon'
      link.href = BIBLION_FAVICON
    })
  }, [isBiblion])

  return null
}

export default BiblionBranding
